import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCompactDisc } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";

import "./song.scss";

library.add(faMapMarkedAlt, faCircle);

const Song: React.FC<ISongProps> = ({ song: songData }) => {
    var image = require(`../../assets/images/artist-album-thumbs/${songData.imageUrl}`);
    return (
        <div className="song">
            <img src={image} alt={songData.songTitle} />
            <div className="info-panel">
                <div className="song-panel">
                    <FontAwesomeIcon icon={faCompactDisc} />
                    <span className="song-text">{songData.songTitle}</span>
                </div>
                <div className="artist-panel">
                    <FontAwesomeIcon icon={faUserCircle} />
                    <span className="artist-text">{songData.artist}</span>
                </div>
            </div>
        </div>
    );
}

export default Song;